import { render, staticRenderFns } from "./InvoiceHistoryApproveForm.vue?vue&type=template&id=4f3f693a"
import script from "./InvoiceHistoryApproveForm.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryApproveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports